import { render, staticRenderFns } from "./ComplianceFormDetailsView.vue?vue&type=template&id=573ca4d4&"
import script from "./ComplianceFormDetailsView.vue?vue&type=script&lang=js&"
export * from "./ComplianceFormDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceFormDetailsView.vue?vue&type=style&index=0&id=573ca4d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports